/**
 * ID 생성 유틸리티
 *
 * @module lib/utils/idUtils
 */

/**
 * 랜덤 ID 생성 (9자리 영문+숫자)
 *
 * @param prefix - ID 앞에 붙일 접두사 (선택)
 * @returns 고유한 랜덤 ID
 */
export function generateRandomId(prefix?: string): string {
  const id = Math.random().toString(36).substring(2, 11);
  return prefix ? `${prefix}-${id}` : id;
}

